import React, { FC, useEffect } from 'react';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import {
    PropertyBox,
    PropertyLabel,
    PropertyList,
    PropertyListItemButton,
} from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type MaterialProps = {
    handleSettings?: (propertyName: string, settingValue: string) => void;
    material: string;
    otherMaterialValue: string;
    isRequired?: boolean;
    options?: string[];
    onChange?: (properties: { material: string; otherMaterial: string }) => void;
};
const Material: FC<MaterialProps> = ({
    material,
    otherMaterialValue,
    handleSettings,
    isRequired,
    options,
    onChange,
}: MaterialProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [selectedMaterial, setSelectedMaterial] = React.useState('');
    const [otherMaterial, setOtherMaterial] = React.useState('');

    useEffect(() => {
        setOtherMaterial(otherMaterialValue || '');
    }, [otherMaterialValue]);

    useEffect(() => {
        setSelectedMaterial(material || '');
    }, [material]);

    const handleListItemClick = (material: string) => {
        setSelectedMaterial(material);
        setOtherMaterial('');
        if (handleSettings) {
            handleSettings('material', material);
            handleSettings('otherMaterial', '');
        }
        if (onChange) {
            onChange({ material, otherMaterial: '' });
        }
    };
    const handleFocus = () => {
        setSelectedMaterial('');
        if (handleSettings) {
            handleSettings('material', '');
        }
    };
    const handleOtherMaterial = (event: React.ChangeEvent) => {
        setOtherMaterial((event.target as HTMLInputElement).value);
        if (handleSettings) {
            handleSettings('otherMaterial', (event.target as HTMLInputElement).value as string);
        }
        if (onChange) {
            onChange({ material: selectedMaterial, otherMaterial: (event.target as HTMLInputElement).value as string });
        }
    };

    const materials = () => {
        return options ? options : CONSTANTS.MATERIALS;
    };

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('MATERIAL')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <PropertyList>
                {materials().map((material) => {
                    return (
                        <PropertyListItemButton
                            key={material}
                            selected={selectedMaterial === material}
                            onClick={() => handleListItemClick(material)}
                        >
                            <ListItemText primary={material} primaryTypographyProps={{ fontSize: '13px' }} />
                        </PropertyListItemButton>
                    );
                })}
            </PropertyList>
            <TextField
                sx={{
                    marginTop: 1,
                    '& .MuiInputBase-root': {
                        height: 32,
                        fontSize: '12px',
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: '12px',
                    },
                }}
                id="outlined-basic"
                value={otherMaterial}
                label={translate('OTHER_MATERIAL')}
                onChange={handleOtherMaterial}
                onFocus={handleFocus}
            />
        </PropertyBox>
    );
};

export default Material;
